import { render } from "./DocumentTemplateModal.vue?vue&type=template&id=f7619b4c&scoped=true"
import script from "./DocumentTemplateModal.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateModal.vue?vue&type=script&lang=js"

import "./DocumentTemplateModal.vue?vue&type=style&index=0&id=f7619b4c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7619b4c"]])

export default __exports__